import { CSSObject } from '@chakra-ui/react';

export const BoxHeaderWrapper: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  flexDir: 'column',
  color: 'white',
  fontWeight: 'medium',
  height: 'auto',
  border: 'none',
  fontSize: 'md',
};

export const FlexHeadingMiscWrapper: CSSObject = {
  zIndex: 'overlay',
  '&&&&': {
    fontSize: 'xs',
    flexDir: ['column', 'row'],
    color: 'alpha.200',
    alignItems: ['flex-start', 'center'],

    '.timestamp': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
  },
};

export const BoxDot: CSSObject = {
  display: ['none', 'block'],
  border: 'none',
  bg: 'whiteAlpha.500',
};

export const TextSportName: CSSObject = {
  '&&&&': {
    fontSize: 'inherit',
    fontWeight: 'inherit',
  },
};

export const TextVS: CSSObject = {
  alignSelf: 'center',
  color: 'white',
};
